import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import { localize } from 'helpers/translator'
import StudentListItem from './StudentListItem'
import styles from './StudentList.scss'

const StudentList = props => (
	<div styleName="StudentList">
		<div styleName="StudentList-title">
			<p>{localize('matching_pairs_dashboard_title')}</p>
		</div>
		<div styleName="StudentList-header">
			<span styleName="StudentList-header-student">{localize('matching_pairs_dashboard_student')}</span>
			<span styleName="StudentList-header-matches">{localize('matching_pairs_dashboard_matches')}</span>
			<span styleName="StudentList-header-tries">{localize('matching_pairs_dashboard_tries')}</span>
		</div>
		{ props.rows.map(student => (
			<StudentListItem
				totalPairs={props.totalPairs}
				finished={student.finished}
				name={props.isDisplayingStudentNames ? student.nickname : '********'}
				matches={student.matches}
				tries={student.tries}
				key={student.device_uid}
			/>
		))}
	</div>
)

StudentList.propTypes = {
	rows: PropTypes.array.isRequired,
}

StudentList.defaultProps = {
	rows: [],
}

export default CSSModules(StudentList, styles, { allowMultiple: true })
